import { render, staticRenderFns } from "./BookingViewTop.vue?vue&type=template&id=0b722613"
import script from "./BookingViewTop.vue?vue&type=script&lang=js"
export * from "./BookingViewTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports